import { apiClientManager } from '@common/api';
export async function validateVmOption(vmOption) {
    await apiClientManager.getClient().post('/api/vm-options/validate-vm-option', vmOption, {
        headers: { 'Content-Type': 'text/plain' }
    });
}
